import { render, staticRenderFns } from "./MoleculeAddressCard.vue?vue&type=template&id=957af3a0&scoped=true&"
import script from "./MoleculeAddressCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeAddressCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAddressCard.vue?vue&type=style&index=0&id=957af3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957af3a0",
  null
  
)

export default component.exports